import React from 'react';
import { Link } from 'react-router-dom';
// import '../styles/Blog.scss';
import dayjs from 'dayjs';
import { DynamicLink } from '../../../components/shared';

type BlogCardProps = {
  tagTitle: string;
  title: string;
  description: string;
  date: string;
  imgSrc?: string;
  linkTo: string; // Add a new prop for the Link destination
};

const BlogCard = ({ tagTitle, title, description, date, imgSrc, linkTo }: BlogCardProps) => {
  return (
    <div className="grid-card-item rounded-4 box-shadow-3">
      <div className="grid-block-main-item bg-gradient rounded-3">
        <div
          className="grid-block-img"
          style={{
            marginLeft: 0,
            height: '100%',
            width: '100%',
          }}
        >
          <DynamicLink url={linkTo}>
            <img src={imgSrc} alt="blog image" />
          </DynamicLink>
        </div>
      </div>
      <div className="grid-block-content">
        <div className="component-tag-title">
          <h5 className="title-tag">{tagTitle}</h5>
        </div>
        <h2 className="fw-bold">{title}</h2>
        <p>{description}</p>
        <span className="text-date">{dayjs(date).format('MMM DD, YYYY')}</span>
      </div>
    </div>
  );
};

export default BlogCard;
